import Helpers from '@helpers';
import * as noUiSlider from 'nouislider';
import 'nouislider/distribute/nouislider.css';
import './customize.css';

$(document).ready(() => {
    const slider = document.getElementById('price-range-slider') as noUiSlider.Instance;
    if (!slider) return;

    const startValue = Number($('#hfildstartset').val());
    const endValue = Number($('#hfildendset').val());

    const min = Number($('#hfildstartprice').val());
    const max = Number($('#hfildendprice').val());

    noUiSlider.create(slider, {
        start: [startValue, endValue],
        connect: true,
        direction: 'rtl',
        range: {
            min,
            max
        },
        format: wNumb({
            decimals: 0,
            thousand: ',',
            postfix: ' تومان'
        })
    });

    slider.noUiSlider.on('update', (values, handle, unencoded) => {
        const [formattedStartPrice, formattedEndPrice] = values;
        const [startPrice, endPrice] = unencoded;

        $('#lblStartPrice').text(Helpers.Utils.ConvertToPersianDigit(formattedStartPrice));
        $('#lblEndPrice').text(Helpers.Utils.ConvertToPersianDigit(formattedEndPrice));

        $('#hfildendprice').val(endPrice);
        $('#hfildstartprice').val(startPrice);
    });
});
